<template>
  <div>
    <v-container v-if="!this.componentReady" class="text-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-progress-linear :value="overallProgress" color="grey lighten-2" height="25" rounded>
            <strong>Gesamtfortschritt: {{ Math.ceil(overallProgress) }}%</strong>
          </v-progress-linear>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(1)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(0)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(0)">mdi-file-document</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.orderReceival.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>

        <v-col>
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(2)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(1)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(1)">mdi-ruler-square</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.measuring.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>

        <v-col>
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(3)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(2)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(2)">mdi-drawing-box</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.designing.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>

        <v-col>
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(4)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(3)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(3)">mdi-factory</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.production.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>

        <v-col>
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(5)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(4)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(4)">mdi-truck-delivery</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.delivery.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>

        <v-col v-if="!hideInstallation">
          <v-card class="pa-1" :min-width="getWidth()+'%'" elevation="0" @click="selectPhase(6)">
            <v-hover v-slot="{ hover }">
              <v-card class="d-flex flex-column justify-center" elevation="0">
                <v-container class="d-flex flex-row justify-center">
                  <v-avatar :color="hover ? '#ffffff' : getColor(5)" size="64" data-voverviewtourstep="4">
                    <v-icon large :color="!hover ? '#ffffff' : getColor(5)">mdi-tools</v-icon>
                  </v-avatar>
                </v-container>
                <v-container class="d-flex flex-row justify-center">{{ $t('vtimeline.phases.assembly.name') }}
                </v-container>
              </v-card>
            </v-hover>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card v-if="isSelected(1)" elevation="0">
            <v-card-title>Auftragseingang</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div>
                    <p>Ihr Auftrag ist bei uns eingegangen und wurde kaufmännisch bearbeitet.</p>
                    <p>Die Auftragsbestätigung und evtl. auch eine Anzahlungsrechnung wurden bereits an Sie versendet.
                    </p>
                    <p>Sollten Sie Fragen zur Abwicklung Ihres Auftrages haben, kontaktieren Sie bitte unsere
                      Auftragsbearbeitung.</p>
                    <p>
                      <b>{{ workOrder.MasterOrder.Clerk.DisplayName }}</b><br />
                      {{ workOrder.MasterOrder.Clerk.Email }}<br />
                      {{ workOrder.MasterOrder.Clerk.PhoneNumber }}<br />
                    </p>
                  </div>
                  <v-list>
                    <v-list-item>
                      <v-list-item-action><v-icon x-large>mdi-file-document-check</v-icon></v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Auftragsbestätigung</v-list-item-title>
                          <v-list-item-subtitle
                            v-if="getMasterOrderOrderConfirmation(workOrder).length < 1">
                            kein Dokument verfügbar</v-list-item-subtitle>
                          <v-list-item-subtitle v-else
                            @click="downloadDocument(workOrder.MasterOrderId, getMasterOrderOrderConfirmation(workOrder))">
                            <a>Download</a>
                          </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <!--<v-list-item>
                      <v-list-item-action><v-checkbox :value="this.timeLineConfig.isPrePaymentDone" disabled></v-checkbox></v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Anzahlungsrechnung</v-list-item-title>
                        <v-list-item-subtitle>Download</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>-->
                  </v-list>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-mitarbeiter-6.jpeg')" min-height="300"
                    max-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card v-else-if="isSelected(2)" elevation="0">
            <v-card-title>Aufmaß</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div v-if="getColor(1) == 'grey'">
                    <p>
                      Damit jeder Balkon, Zaun und jede Überdachung Ihren individuellen Vorstellungen entspricht, misst
                      ein Aufmaßtechniker vor Ort alle Längen, Abstände, Winkel und Gefälle.
                      Diese Infos werden daraufhin an unsere technischen Zeichner übermittelt, die einen Plan erstellen,
                      der genau an die örtlichen Gegebenheiten angepasst ist.
                    </p>
                    <p>
                      Der für Ihren Auftrag zuständige Aufmaßtechniker wird Sie bezüglich eines Aufmaßtermins direkt
                      kontaktieren.
                      Sollten Vorarbeiten erforderlich sein, so bitten wir Sie, uns ständig bezüglich des Fortschritts
                      am laufenden zu halten (evtl. Verzögerungen, Abschluss der Arbeiten etc.)
                    </p>
                  </div>

                  <div v-if="getColor(1) == 'orange'">
                    <p>
                      Damit jeder Balkon, Zaun und jede Überdachung Ihren individuellen Vorstellungen entspricht, misst
                      ein Aufmaßtechniker vor Ort alle Längen, Abstände, Winkel und Gefälle.
                      Diese Infos werden daraufhin an unsere technischen Zeichner übermittelt, die einen Plan erstellen,
                      der genau an die örtlichen Gegebenheiten angepasst ist.
                    </p>
                    <v-card elevation="0" v-if="measurementOrder.Id != undefined">
                      <v-card-title>Vereinbarter Termin</v-card-title>
                      <v-card-subtitle v-if="measurementOrder.MeasuringDate != null">{{
                      $d(Date.parse(this.measurementOrder.MeasuringDate), 'short') }}</v-card-subtitle>
                      <v-card-subtitle v-else>noch kein Termin vereinbart</v-card-subtitle>
                    </v-card>
                    <div v-if="measurementOrder.Id != undefined">
                      <p>
                        <b>{{ measurementOrder.Technician.DisplayName }}</b><br />
                        {{ measurementOrder.Technician.Email }}<br />
                        {{ measurementOrder.Technician.PhoneNumber }}<br />
                      </p>
                    </div>
                    <!-- @Joel Strasser: Vorarbeiten sind noch nicht einsatzbereit.
                    <v-card elevation="0" v-if="measurementOrder.Id != undefined">
                      <v-card-title>Vorarbeiten</v-card-title>
                      <v-card-subtitle>Arbeiten, welche noch von Ihnen voarab zu erledigen sind.</v-card-subtitle>
                      <v-card-text>
                      <v-data-table
                        :headers="previousWorksHeaders"
                        :items="measurementOrder.MeasurementOrdersPreviousWorks"
                        :items-per-page="10"
                        :loading="measurementOrder.Id == undefined"
                        :hide-default-footer="true"
                        :hide-default-header="false"
                        :item-key="'Id'"
                        v-model="measurementOrder.MeasurementOrdersPreviousWorks"
                      >
                        </!--<template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            @click="$router.push({path: '/overview', query: { id: item.MasterOrderId }}).catch(error => {})"
                          >
                            mdi-email-outline
                          </v-icon>
                        </template>--/>
                        <template  v-slot:[`item.IsDone`]="props">
                        <v-edit-dialog
                          :return-value.sync="props.item.IsDone"
                          large
                          persistent
                          
                        >
                          <div>{{ props.item.IsDone }}</div>
                          <template v-slot:input>
                            <div class="mt-4 text-h6">
                              Erledigt ändern
                            </div>
                            <v-checkbox
                              v-model="props.item.IsDone"
                              label="Erledigt?"
                              single-line
                              autofocus
                            ></v-checkbox>
                          </template>
                        </v-edit-dialog>
                      </template>
                      </v-data-table>
                      </v-card-text>
                    </v-card>
                    -->
                  </div>

                  <div v-if="getColor(1) == 'green'">
                    <p>
                      Das Aufmaß für Ihren Auftrag liegt vor und ist die Grundlage für die weitere technische
                      Bearbeitung.
                    </p>
                  </div>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-mitarbeiter-27.jpg')" min-height="300"
                    max-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card v-else-if="isSelected(3)" elevation="0">
            <v-card-title>Konstruktion</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div v-if="getColor(2) == 'grey'">
                    <p>
                      Die technische Bearbeitung und Konstruktion Ihres Auftrages starten demnächst.
                      In dieser Phase werden die technischen Zeichnungen zur maßgenauen Fertigung Ihres Auftrages von
                      unseren Technikern vorbereitet.
                    </p>
                  </div>
                  <div>
                    <div v-if="getColor(2) == 'orange'">
                      <p>
                        Die technische Bearbeitung und Konstruktion Ihres Auftrages sind aktuell in Arbeit. Sofern vor
                        der Produktion eine Freigabe erforderlich ist, wird Sie der zuständige Zeichner kontaktieren.
                      </p>
                    </div>
                    <div v-if="getColor(2) == 'green'">
                      <p>
                        Die technische Bearbeitung und Konstruktion Ihres Auftrages sind abgeschlossen. Sämtliche
                        technischen Zeichnungen und Unterlagen für die Fertigung sind vorbereitet.
                      </p>
                    </div>
                    <!--<p>
                      <v-list>
                        <v-list-item>
                          <v-list-item-action><v-checkbox :value="this.timeLineConfig.isTechnicalCheckCompleted" disabled></v-checkbox></v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Technische Prüfung</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-action><v-checkbox :value="this.timeLineConfig.isPlanReleased" disabled></v-checkbox></v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>Freigabeplan</v-list-item-title>
                            <v-list-item-subtitle>Download</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </p>-->
                  </div>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-mitarbeiter.jpg')" max-height="300"
                    min-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card v-else-if="isSelected(4)" elevation="0">
            <v-card-title>Produktion</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div v-if="getColor(3) == 'grey'">
                    <p>
                      Die Fertigung Ihres Auftrages beginnt demnächst.
                    </p>
                  </div>
                  <div v-if="getColor(3) == 'orange'">
                    <p>
                      Die Fertigung Ihres Auftrages hat bereits begonnen. Es dauert nicht mehr lange, bis wir ihr
                      bestelltes Produkt liefern bzw. montieren können.
                    </p>
                  </div>
                  <div v-if="getColor(3) == 'green'">
                    <p>
                      Die Fertigung Ihres Auftrages ist abgeschlossen.
                    </p>
                  </div>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-mitarbeiter-15.jpg')" max-height="300"
                    min-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card v-else-if="isSelected(5)" elevation="0">
            <v-card-title>Lieferung</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div v-if="getColor(4) == 'grey'">
                    <p>
                      In Ihrer Auftragsbestätigung, die Sie von uns bekommen, finden Sie die Kalenderwoche Ihres
                      avisierten Liefer- bzw. Montagetermins.
                      Rund 3-4 Wochen vor dem avisierten Termin kontaktieren wir Sie nochmals zur Feinabstimmung.
                    </p>
                  </div>
                  <div v-if="getColor(4) == 'orange'">
                    <p>
                      Die Feinplanung der Lieferung ihres Auftrags hat begonnen.
                      Um die Termindetails mit Ihnen abzustimmen, werden sich die Mitarbeiter aus unserer Logistik bei
                      Ihnen melden.
                    </p>
                    <v-card elevation="0">
                      <v-card-title>Vorraussichtlicher Liefertermin</v-card-title>
                      <v-card-subtitle v-if="this.timeLineConfig.expectedDeliveryDate == null">
                        <i>noch kein Termin festgelegt</i>
                      </v-card-subtitle>
                      <v-card-subtitle v-else-if="this.timeLineConfig.showExpectedDeliveryDateAsCalendarWeek == true">
                        Kalenderwoche {{ convertToLuxonDate(new Date(Date.parse(this.timeLineConfig.expectedDeliveryDate))).weekNumber }}
                      </v-card-subtitle>
                      <v-card-subtitle v-else>
                        {{ $d(Date.parse(this.timeLineConfig.expectedDeliveryDate), 'short') }}
                      </v-card-subtitle>
                    </v-card>
                    <v-alert v-if="this.timeLineConfig.isExpectedDeliveryToWarehouse == true" type="info" outlined text>
                      <h3>{{ $t('vtimeline.phases.delivery.warehouseDeliveryInfo.title') }}</h3>
                      {{ $t('vtimeline.phases.delivery.warehouseDeliveryInfo.subtitle') }}
                    </v-alert>
                  </div>
                  <div v-if="getColor(4) == 'green'">
                    <p>
                      Die Lieferung ihres Auftrags ist abgeschlossen.
                    </p>
                    <v-card elevation="0">
                      <v-card-title>Tatsächlicher Liefertermin</v-card-title>
                      <v-card-subtitle v-if="this.timeLineConfig.actualDeliveryDate == null">kein Datum vorhanden
                      </v-card-subtitle>
                      <v-card-subtitle v-else>{{ $d(Date.parse(this.timeLineConfig.actualDeliveryDate), 'short') }}
                      </v-card-subtitle>
                    </v-card>
                    <v-alert v-if="this.timeLineConfig.isExpectedDeliveryToWarehouse == true" type="info" outlined text>
                      <h3>{{ $t('vtimeline.phases.delivery.warehouseDeliveryInfo.title') }}</h3>
                      {{ $t('vtimeline.phases.delivery.warehouseDeliveryInfo.subtitle') }}
                    </v-alert>
                  </div>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-transporter.jpeg')" max-height="300"
                    min-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card v-else-if="isSelected(6)" elevation="0">
            <v-card-title>Montage</v-card-title>
            <v-card-text>
              <v-row>
                <v-col lg="6" cols="12">
                  <div v-if="getColor(5) == 'grey'">
                    <p>
                      In Ihrer Auftragsbestätigung, die Sie von uns bekommen, finden Sie die Kalenderwoche Ihres
                      avisierten Liefer- bzw. Montagetermins.
                      Rund 3-4 Wochen vor dem avisierten Termin kontaktieren wir Sie nochmals zur Feinabstimmung.
                    </p>
                  </div>
                  <div v-if="getColor(5) == 'orange'">
                    <p>
                      Die Montage Ihres Auftrags wird in Kürze erfolgen. Die Mitarbeiter aus unserer Logistik bzw.
                      unsere Montagepartner werden Sie zur Abstimmung des genauen Termins kontaktieren.
                    </p>
                    <p>
                      <b>{{ $t('vtimeline.phases.assembly.dateMayVary') }}</b>
                    </p>
                    <v-card elevation="0">
                      <v-card-title>Vorraussichtlicher Montagetermin</v-card-title>
                      <v-card-subtitle v-if="this.timeLineConfig.expectedAssemblyDate == null">
                        <i>noch kein Termin festgelegt</i>
                      </v-card-subtitle>
                      <v-card-subtitle v-else-if="this.timeLineConfig.showExpectedAssemblyDateAsCalendarWeek == true">
                        Kalenderwoche {{ convertToLuxonDate(new Date(Date.parse(this.timeLineConfig.expectedAssemblyDate))).weekNumber }}
                      </v-card-subtitle>
                      <v-card-subtitle v-else>
                        {{ $d(Date.parse(this.timeLineConfig.expectedAssemblyDate), 'short') }}
                      </v-card-subtitle>
                    </v-card>
                  </div>
                  <div v-if="getColor(5) == 'green'">
                    <p>
                      Die Montage ihres Auftrags ist abgeschlossen.
                    </p>
                    <v-card elevation="0">
                      <v-card-title>Tatsächlicher Montagetermin</v-card-title>
                      <v-card-subtitle v-if="this.timeLineConfig.actualAssemblyDate == null">kein Datum vorhanden</v-card-subtitle>
                      <v-card-subtitle v-else>{{ $d(Date.parse(this.timeLineConfig.actualAssemblyDate), 'short') }}</v-card-subtitle>
                    </v-card>
                    <v-list>
                      <v-list-item>
                        <v-list-item-action>
                          <v-icon x-large>mdi-clipboard-text</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>Montagebericht</v-list-item-title>
                          <v-list-item-subtitle
                            v-if="getFieldOrderAssemblyReport(workOrder, workOrder.WorkOrderFieldOrders[0].FieldOrder).length < 1">
                            kein Dokument verfügbar</v-list-item-subtitle>
                          <v-list-item-subtitle v-else
                            @click="downloadDocument(workOrder.MasterOrderId, getFieldOrderAssemblyReport(workOrder, workOrder.WorkOrderFieldOrders[0].FieldOrder))">
                            <a>Download</a>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
                <v-col lg="6" cols="12" class="d-none d-lg-flex">
                  <v-img :src="require('@/assets/leeb-images/leeb-balkone-mitarbeiter-4.jpeg')" max-height="300"
                    min-height="300"></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import dataAssembler from '../plugins/dataAssembler';
import { DateTime } from 'luxon';
var contentDisposition = require('content-disposition');
import {saveAs} from 'file-saver';

export default {
  name: "time-line",
  data() {
    return {
      timeLineConfig: {},
      workOrder: {},
      measurementOrder: {},
      colors: [],
      overallProgress: 0,
      hideInstallation: false,
      selectedPhase: 0,
      previousWorksHeaders: [
        {text: 'Vorarbeit', value: 'PreviousWork.Description', sortable: false, align: 'start'},
        {text: 'Erledigt?', value: 'IsDone', sortable: false}
      ],
      selectedPreviousWork: {},
      documents: [],
      assemblyReport: undefined,
      // ready to show?
      componentReady: false
    }
  },
  props: {
    workOrderId: Number,
  },
  methods: {
    selectPhase(val) {
      this.selectedPhase = val;
      this.$forceUpdate();
    },
    getColor(position) {
      return this.colors[position];
    },
    getWidth() {
      return 100/(this.colors.length-(this.hideInstallation?1:0));
    },
    getFieldOrderAssemblyReport(workOrder, fieldOrder) {
      return dataAssembler.getFieldOrderAssemblyReport(workOrder.MasterOrder.OrderNumber, fieldOrder, this.documents);
    },
    getMasterOrderOrderConfirmation(workOrder) {
      return dataAssembler.getOrderConfirmations(workOrder.MasterOrder.OrderNumber, this.documents);
    },
    isDividerVertical() {
      return ['lg', 'xl'].findIndex((val) => val == this.$vuetify.breakpoint.name) != -1;
    },
    /**
     * Checks if current phase is selected.
     */
    isSelected(pos) {
      return this.selectedPhase == pos;
    },
    /**
     * Converts given Date to a Luxon DateTime.
     * @param date An ordinary JavaScript date.
     */
    convertToLuxonDate(date) {
      return DateTime.fromJSDate(date);
    },
    loadWorkOrder(workOrderId) {
      this.$http(dataAssembler.constructWorkOrdersAxiosQuery(workOrderId, this.$store.getters.customerNumber(), this.$store.getters.getToken())).then((res) => {
        this.workOrder = res.data;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      })
    },
    loadMeasurementOrder(measurementOrderId) {
      this.$http(dataAssembler.constructMeasurementOrdersAxiosQuery(this.$store.getters.getToken(), measurementOrderId, this.$store.getters.customerNumber())).then((res) => {
        this.measurementOrder = res.data;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      })
    },
    loadDocuments(masterOrderId) {
      this.$http({
        method: "get",
        url: "/api/v1/Documents",
        params: {
          masterOrderId: masterOrderId,
          customerNumber: this.$store.getters.customerNumber()
        },
        headers: { Authorization: "Bearer " + this.$store.getters.getToken() },
      }).then((response) => {
        this.documents = response.data;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      });
    },
    downloadDocument(masterOrderId, document) {
      this.$http(
        {
          url: '/api/v1/Documents/Download',
          method: "get",
          params: {
            masterOrderId: masterOrderId,
            folderId: document.FolderId,
            fileId: document.DocumentId,
            customerNumber: this.$store.getters.customerNumber()
          },
          headers: { Authorization: "Bearer " + this.$store.getters.getToken() },
          responseType: 'blob'
        }
      ).then((response) => {
        saveAs(response.data, Buffer.from(contentDisposition.parse(response.headers["content-disposition"]).parameters.filename, 'base64'));
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Ein Fehler ist aufgetreten', 'red darken-1');
      });
    },
    /**
     * Initialize pre-selected phase
     */
    handleInit() {
      this.timeLineConfig = dataAssembler.calculateTimeLineConfig(this.workOrder.WorkOrderFieldOrders, this.workOrder.Events, this.workOrder.WorkOrderFlag, this.workOrder.IsInstallationOrder);
      this.colors = this.timeLineConfig.colors;
      this.hideInstallation = this.timeLineConfig.hideInstallationOrder;
      this.overallProgress = this.timeLineConfig.percent;

      // First orange ...
      let lastTimelinePhase = this.colors.findIndex((value) => value === "orange");

      // ... or last green.
      if(lastTimelinePhase === -1) {
        lastTimelinePhase = this.colors.lastIndexOf("green");
      }

      if(lastTimelinePhase === -1) {
        this.selectedPhase = 0;
      } else {
        this.selectedPhase = lastTimelinePhase + 1;
      }
    }
  },
  created() {
    this.loadWorkOrder(this.workOrderId);
  },
  watch: {
    workOrderId() {
      this.componentReady = false;
      this.loadWorkOrder(this.workOrderId);
    },
    workOrder() {
      this.handleInit();
      this.loadDocuments(this.workOrder.MasterOrderId);
      if (this.workOrder.WorkOrderMeasurementOrders.length > 0) {
        this.loadMeasurementOrder(this.workOrder.WorkOrderMeasurementOrders[0].MeasurementOrder.Id);
      } else {
        this.measurementOrder = {};
      }
    },
    documents() {
      this.componentReady = true;
    }
  }
};
</script>